import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
var render = function render() {
  var _vm$device_list$_vm$a;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login"
  }, [_vm._m(0), _c("div", {
    staticClass: "back",
    on: {
      click: _vm.backClick
    }
  }, [_c("img", {
    attrs: {
      src: require("./image/back.png"),
      alt: ""
    }
  })]), _vm.show ? _c("div", {
    staticClass: "operation operation-1",
    on: {
      click: function click($event) {
        _vm.show = false;
      }
    }
  }, [_c("i", {
    staticClass: "el-icon-caret-left",
    staticStyle: {
      transform: "translateX(20%)"
    }
  }), _c("i", {
    staticClass: "el-icon-caret-right",
    staticStyle: {
      transform: "translateX(-20%)"
    }
  })]) : _c("div", {
    staticClass: "operation operation-2",
    on: {
      click: function click($event) {
        _vm.show = true;
      }
    }
  }, [_c("i", {
    staticClass: "el-icon-caret-right",
    staticStyle: {
      transform: "translateX(20%)"
    }
  }), _c("i", {
    staticClass: "el-icon-caret-left",
    staticStyle: {
      transform: "translateX(-20%)"
    }
  })]), _c("div", {
    staticClass: "content"
  }, [_vm.show ? _c("div", {
    staticClass: "left"
  }, [_c("div", {
    staticClass: "warn"
  }, [_vm._m(1), _c("div", {
    staticClass: "warn-content"
  }, [_vm._l((_vm$device_list$_vm$a = _vm.device_list[_vm.active]) === null || _vm$device_list$_vm$a === void 0 ? void 0 : _vm$device_list$_vm$a.lastData, function (item, key) {
    return _c("div", {
      key: key,
      staticClass: "item"
    }, [item.name === "溶解氧" && _vm.active == 4 && _vm.video1 == "8号水上" ? _c("div", {
      staticClass: "now"
    }, [_c("div", {
      staticClass: "label"
    }, [_vm._v("溶解氧 (mg/L)")]), _c("div", {
      staticClass: "value level-1"
    }, [_c("div", {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.mockData || 6.2))]), _c("div", [_vm._v("等级：优")])])]) : _c("div", {
      staticClass: "now"
    }, [_c("div", {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name) + " " + _vm._s(item.unit ? "(".concat(item.unit, ")") : ""))]), _c("div", {
      staticClass: "value",
      class: {
        "level-1": item.level == "优",
        "level-2": item.level == "良",
        "level-3": item.level == "中",
        "level-4": item.level == "差"
      }
    }, [_c("div", {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.itemValue))]), _c("div", [_vm._v("等级：" + _vm._s(item.level))])])]), item.name === "溶解氧" && _vm.active == 4 && _vm.video1 == "8号水上" ? _c("div", {
      staticClass: "forecast"
    }, _vm._l(item.forecastValues, function (opt, idx) {
      return _c("div", {
        key: idx
      }, [_c("div", {
        staticClass: "value level-1"
      }, [_vm._v(" " + _vm._s(_vm.getRandomFloat((_vm.mockData || 6.2) - 0.5, Number(_vm.mockData || 6.2) + 0.5, 1)) + " ")]), _c("div", {
        staticClass: "label"
      }, [idx === 0 ? _c("div", [_vm._v("30分钟后")]) : _vm._e(), idx === 1 ? _c("div", [_vm._v("60分钟后")]) : _vm._e(), idx === 2 ? _c("div", [_vm._v("1小时后")]) : _vm._e(), idx === 3 ? _c("div", [_vm._v("1.5小时后")]) : _vm._e(), _c("div", [_vm._v("预测值")])])]);
    }), 0) : _c("div", {
      staticClass: "forecast"
    }, _vm._l(item.forecastValues, function (opt, idx) {
      return _c("div", {
        key: idx
      }, [_c("div", {
        staticClass: "value",
        class: {
          "level-1": item.level == "优",
          "level-2": item.level == "良",
          "level-3": item.level == "中",
          "level-4": item.level == "差"
        }
      }, [_vm._v(" " + _vm._s(opt) + " ")]), _c("div", {
        staticClass: "label"
      }, [idx === 0 ? _c("div", [_vm._v("30分钟后")]) : _vm._e(), idx === 1 ? _c("div", [_vm._v("60分钟后")]) : _vm._e(), idx === 2 ? _c("div", [_vm._v("1小时后")]) : _vm._e(), idx === 3 ? _c("div", [_vm._v("1.5小时后")]) : _vm._e(), _c("div", [_vm._v("预测值")])])]);
    }), 0)]);
  }), _c("div", {
    staticClass: "item"
  }, [_vm._m(2), _c("div", {
    staticClass: "forecast"
  }, _vm._l(4, function (opt, idx) {
    return _c("div", {
      key: idx
    }, [_c("div", {
      staticClass: "value level-1"
    }, [_vm._v(_vm._s(35 + idx * 3))]), _c("div", {
      staticClass: "label"
    }, [idx === 0 ? _c("div", [_vm._v("30分钟后")]) : _vm._e(), idx === 1 ? _c("div", [_vm._v("60分钟后")]) : _vm._e(), idx === 2 ? _c("div", [_vm._v("1小时后")]) : _vm._e(), idx === 3 ? _c("div", [_vm._v("1.5小时后")]) : _vm._e(), _c("div", [_vm._v("预测值")])])]);
  }), 0)])], 2)]), _c("div", {
    staticClass: "feed"
  }, [_vm._m(3), _c("div", {
    staticClass: "feed-content"
  }, [_c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("投喂策略")]), _c("div", {
    staticClass: "option"
  }, [_c("div", [_c("div", {
    staticClass: "label"
  }, [_vm._v("建议投喂量")]), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.feedLogs[_vm.active].ammount) + "kg")])]), _c("div", [_c("div", {
    staticClass: "label"
  }, [_vm._v("建议次数")]), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.feedLogs[_vm.active].number) + "次")])])])]), _vm._m(4), _vm._m(5), _c("div", {
    staticClass: "item table-item"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("投喂记录")]), _c("div", {
    staticClass: "table"
  }, [_vm._m(6), _c("div", {
    staticClass: "t-content"
  }, _vm._l(_vm.feed_logs, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "tr"
    }, [_c("div", {
      staticClass: "td"
    }, [_vm._v(_vm._s(item.time))]), _c("div", {
      staticClass: "td"
    }, [_vm._v(_vm._s(item.weight) + "kg")])]);
  }), 0)])])])])]) : _vm._e(), _c("div", {
    staticClass: "center"
  }, [_vm.show ? _c("div", {
    staticClass: "top"
  }, [_c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260818/1787029286347.png",
      alt: ""
    },
    on: {
      click: _vm.scrollLeft
    }
  }), _c("div", {
    ref: "scrollContainer",
    staticClass: "scroll-wrapper"
  }, [_c("div", {
    ref: "scrollContent",
    staticClass: "scroll-content"
  }, _vm._l(_vm.device_list, function (item, index) {
    return _c("div", {
      key: item.id,
      staticClass: "top-item",
      class: {
        "top-active": _vm.active == index
      },
      on: {
        click: function click($event) {
          ;
          _vm.active = index, _vm.ChartInit();
        }
      }
    }, [_c("img", {
      attrs: {
        src: "https://oss-mng.rich-link.cn/undefined/20260615/1781508024202.png",
        alt: ""
      }
    }), _c("div", [_vm._v(_vm._s(item.name))])]);
  }), 0)]), _c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260818/1787029303881.png",
      alt: ""
    },
    on: {
      click: _vm.scrollRight
    }
  })]) : _vm._e(), _c("div", {
    staticClass: "iframe",
    style: !_vm.show ? "height:100%" : ""
  }, [_c("iframe", {
    staticStyle: {
      width: "100%",
      height: "100%"
    },
    attrs: {
      src: "https://3d.rich-link.cn/editor/index.html#/publish?id=400&tenantNo=SYS",
      frameborder: "0"
    }
  })]), _vm.show ? _c("div", {
    staticClass: "price"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._m(7), _c("div", {
    staticClass: "text"
  }, [_vm._v("价格分析")]), _c("div", {
    staticClass: "input"
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "120px"
    },
    attrs: {
      type: "date",
      size: "small",
      placeholder: "统计日期",
      format: "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: _vm.price_params.productionDate,
      callback: function callback($$v) {
        _vm.$set(_vm.price_params, "productionDate", $$v);
      },
      expression: "price_params.productionDate"
    }
  }), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.price_params.reportOrigin,
      expression: "price_params.reportOrigin"
    }],
    staticStyle: {
      width: "130px"
    },
    attrs: {
      type: "text",
      placeholder: "请输入统计地区"
    },
    domProps: {
      value: _vm.price_params.reportOrigin
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.price_params, "reportOrigin", $event.target.value);
      }
    }
  }), _c("div", {
    staticClass: "open btn",
    on: {
      click: _vm.getPriceList
    }
  }, [_vm._v("查询")])], 1)]), _c("div", {
    staticClass: "price-content"
  }, [_c("div", {
    staticClass: "table"
  }, [_vm._m(8), _c("el-carousel", {
    staticClass: "t-content",
    attrs: {
      direction: "vertical",
      autoplay: true,
      loop: true,
      arrow: "never",
      "indicator-position": "none"
    }
  }, _vm._l(_vm.price_list, function (item, index) {
    return _c("el-carousel-item", {
      key: index
    }, _vm._l(item, function (opt, idx) {
      return _c("div", {
        key: opt.id,
        staticClass: "tr"
      }, [_c("div", {
        staticClass: "td"
      }, [_vm._v(_vm._s(opt.placeOrigin))]), _c("div", {
        staticClass: "td",
        staticStyle: {
          flex: "none",
          width: "100px"
        }
      }, [_vm._v(_vm._s(opt.specName))]), _c("div", {
        staticClass: "td",
        staticStyle: {
          flex: "none",
          width: "120px"
        }
      }, [_vm._v(_vm._s(opt.price) + " 元")]), _c("div", {
        staticClass: "td",
        staticStyle: {
          flex: "none",
          width: "120px"
        }
      }, [_vm._v(_vm._s(_vm.dayjs(opt.productionDate).format("YYYY-MM-DD")))])]);
    }), 0);
  }), 1)], 1)])]) : _vm._e()]), _vm.show ? _c("div", {
    staticClass: "right"
  }, [_c("div", {
    staticClass: "videos"
  }, [_c("div", {
    staticClass: "video video-1"
  }, [_c("div", {
    staticClass: "title name"
  }, [_vm._m(9), _c("div", {
    staticClass: "text"
  }, [_vm._v("水上监控")]), _c("div", {
    staticClass: "open"
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: "请选择",
      size: "mini"
    },
    model: {
      value: _vm.video1,
      callback: function callback($$v) {
        _vm.video1 = $$v;
      },
      expression: "video1"
    }
  }, _vm._l(_vm.video1_list, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.videoName,
        value: item.id
      }
    });
  }), 1)], 1)]), _c("div", {
    staticClass: "video-container"
  }, [_vm.video1 === "7号水上" && !_vm.videoShow ? _c("video", {
    attrs: {
      src: "https://rclk-gy.oss-cn-beijing.aliyuncs.com/tulufan/TLF_001.mp4",
      loop: "",
      autoplay: ""
    }
  }) : _vm.video1 === "8号水上" && !_vm.videoShow ? _c("video", {
    attrs: {
      src: "https://rclk-gy.oss-cn-beijing.aliyuncs.com/tulufan/TLF_003.mp4",
      loop: "",
      autoplay: ""
    }
  }) : _vm.video1 && !_vm.videoShow ? _c("m3u8Video", {
    attrs: {
      id: _vm.video1
    }
  }) : _vm._e(), _c("i", {
    staticClass: "el-icon-full-screen",
    on: {
      click: function click($event) {
        ;
        _vm.videoId = _vm.video1, _vm.videoShow = true;
      }
    }
  })], 1)]), _c("div", {
    staticClass: "video video-1"
  }, [_c("div", {
    staticClass: "title name"
  }, [_vm._m(10), _c("div", {
    staticClass: "text"
  }, [_vm._v("水下视频")]), _c("div", {
    staticClass: "open"
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: "请选择",
      size: "mini"
    },
    model: {
      value: _vm.video2,
      callback: function callback($$v) {
        _vm.video2 = $$v;
      },
      expression: "video2"
    }
  }, _vm._l(_vm.video2_list, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.videoName,
        value: item.id
      }
    });
  }), 1)], 1)]), _c("div", {
    staticClass: "video-container"
  }, [_vm.video2 === "9号水下" && !_vm.videoShow ? _c("video", {
    attrs: {
      src: "https://rclk-gy.oss-cn-beijing.aliyuncs.com/tulufan/TLF_002.mp4",
      loop: "",
      autoplay: ""
    }
  }) : !_vm.videoShow ? _c("m3u8Video", {
    attrs: {
      id: _vm.video2
    }
  }) : _vm._e(), _c("i", {
    staticClass: "el-icon-full-screen",
    on: {
      click: function click($event) {
        ;
        _vm.videoId = _vm.video2, _vm.videoShow = true;
      }
    }
  })], 1)])]), _c("div", {
    staticClass: "energy"
  }, [_vm._m(11), _c("div", {
    staticClass: "energy-content"
  }, [_vm._m(12), _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("设备实时数据")]), _c("div", {
    staticClass: "options"
  }, _vm._l(_vm.meter_list, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "option"
    }, [_c("img", {
      attrs: {
        src: "https://oss-mng.rich-link.cn/undefined/20260615/1781508110925.png",
        alt: ""
      }
    }), _c("div", [_c("div", {
      staticClass: "option-title"
    }, [_c("div", {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.deviceName))]), _c("div", {
      staticClass: "btn",
      on: {
        click: function click($event) {
          return _vm.meterClick(item);
        }
      }
    }, [_vm._v("查看历史曲线")])]), _c("div", {
      staticClass: "values"
    }, [_c("div", [_vm._v("A相:" + _vm._s(Number(item.iaLatestValue || 0).toFixed(2) || "--") + "A")]), _c("div", [_vm._v("B相:" + _vm._s(Number(item.ibLatestValue || 0).toFixed(2) || "--") + "A")]), _c("div", [_vm._v("C相:" + _vm._s(Number(item.icLatestValue || 0).toFixed(2) || "--") + "A")])])])]);
  }), 0)])])]), _c("div", [_vm._m(13), _c("div", {
    staticClass: "mode-video-container"
  }, [_c("iframe", {
    staticStyle: {
      width: "100%",
      height: "100%"
    },
    attrs: {
      src: "".concat(_vm.labInfo.modelUrl, "?v=").concat(_vm.dayjs().valueOf()),
      frameborder: "0"
    }
  })])])]) : _vm._e()]), _c("el-dialog", {
    attrs: {
      visible: _vm.dialogVisible,
      title: "".concat(_vm.meterData.deviceName, "\u5386\u53F2\u66F2\u7EBF")
    },
    on: {
      close: function close($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_c("div", {
    staticClass: "dialog-container"
  }, [_c("div", {
    attrs: {
      id: "largeHall-lineChart"
    }
  })])]), _vm.dialogShow ? _c("div", {
    staticClass: "pupop",
    staticStyle: {
      "z-index": "1000"
    }
  }, [_c("div", {
    staticClass: "dialog"
  }, [_c("div", {
    staticClass: "btn",
    on: {
      click: function click($event) {
        _vm.dialogShow = false;
      }
    }
  }, [_vm._v("关闭")]), _c("div", {
    staticClass: "dialog-content"
  }, [_c("iframe", {
    staticStyle: {
      width: "100%",
      height: "100%"
    },
    attrs: {
      src: "".concat(_vm.labInfo.modelUrl, "?v=").concat(_vm.dayjs().valueOf()),
      frameborder: "0"
    }
  })])])]) : _vm._e(), _vm.videoShow ? _c("div", {
    staticClass: "video-dialog"
  }, [_c("i", {
    staticClass: "el-icon-error close",
    on: {
      click: function click($event) {
        _vm.videoShow = false;
      }
    }
  }), _vm.videoId === "7号水上" ? _c("video", {
    attrs: {
      src: "https://rclk-gy.oss-cn-beijing.aliyuncs.com/tulufan/TLF_001.mp4",
      loop: "",
      autoplay: ""
    }
  }) : _vm.videoId === "8号水上" ? _c("video", {
    attrs: {
      src: "https://rclk-gy.oss-cn-beijing.aliyuncs.com/tulufan/TLF_003.mp4",
      loop: "",
      autoplay: ""
    }
  }) : _vm.videoId === "9号水下" ? _c("video", {
    attrs: {
      src: "https://rclk-gy.oss-cn-beijing.aliyuncs.com/tulufan/TLF_002.mp4",
      loop: "",
      autoplay: ""
    }
  }) : _c("m3u8Video", {
    attrs: {
      id: _vm.videoId
    }
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "header"
  }, [_c("div", {
    staticClass: "text"
  }, [_vm._v("吐鲁番数智三文鱼产业大脑")]), _c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260615/1781508906978.png",
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title"
  }, [_c("div", {
    staticClass: "title-bg"
  }, [_c("div", {
    staticClass: "line"
  }), _c("div", {
    staticClass: "title-bg-content"
  }, [_c("i", {
    staticClass: "el-icon-caret-right"
  })])]), _c("div", {
    staticClass: "text"
  }, [_vm._v("水质预测预警")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "now"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("浊度 (NTU)")]), _c("div", {
    staticClass: "value level-1"
  }, [_c("div", {
    staticClass: "num"
  }, [_vm._v("35")]), _c("div", [_vm._v("等级：优")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title"
  }, [_c("div", {
    staticClass: "title-bg"
  }, [_c("div", {
    staticClass: "line"
  }), _c("div", {
    staticClass: "title-bg-content"
  }, [_c("i", {
    staticClass: "el-icon-caret-right"
  })])]), _c("div", {
    staticClass: "text"
  }, [_vm._v("饵料投喂")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("饵料名称")]), _c("div", {
    staticClass: "option"
  }, [_vm._v("爱乐6.0mm")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("每日投喂曲线")]), _c("div", {
    staticClass: "chart",
    attrs: {
      id: "largeHall-chart"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "th"
  }, [_c("div", {
    staticClass: "td"
  }, [_vm._v("投饵时间")]), _c("div", {
    staticClass: "td"
  }, [_vm._v("投饵量")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-bg"
  }, [_c("div", {
    staticClass: "line"
  }), _c("div", {
    staticClass: "title-bg-content"
  }, [_c("i", {
    staticClass: "el-icon-caret-right"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "th"
  }, [_c("div", {
    staticClass: "td"
  }, [_vm._v("产地/厂家")]), _c("div", {
    staticClass: "td",
    staticStyle: {
      flex: "none",
      width: "100px"
    }
  }, [_vm._v("规格")]), _c("div", {
    staticClass: "td",
    staticStyle: {
      flex: "none",
      width: "120px"
    }
  }, [_vm._v("价格")]), _c("div", {
    staticClass: "td",
    staticStyle: {
      flex: "none",
      width: "120px"
    }
  }, [_vm._v("产地生产日期")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-bg"
  }, [_c("div", {
    staticClass: "line"
  }), _c("div", {
    staticClass: "title-bg-content"
  }, [_c("i", {
    staticClass: "el-icon-caret-right"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-bg"
  }, [_c("div", {
    staticClass: "line"
  }), _c("div", {
    staticClass: "title-bg-content"
  }, [_c("i", {
    staticClass: "el-icon-caret-right"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title"
  }, [_c("div", {
    staticClass: "title-bg"
  }, [_c("div", {
    staticClass: "line"
  }), _c("div", {
    staticClass: "title-bg-content"
  }, [_c("i", {
    staticClass: "el-icon-caret-right"
  })])]), _c("div", {
    staticClass: "text"
  }, [_vm._v("装备能耗")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "today"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("今日用电量")]), _c("div", {
    staticClass: "data"
  }, [_c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260817/1786936649054.png",
      alt: ""
    }
  }), _c("div", [_c("div", {
    staticClass: "value"
  }, [_vm._v("1400 "), _c("span", [_vm._v("kwh")])]), _c("div", {
    staticClass: "label"
  }, [_vm._v("较昨日增加 "), _c("span", {
    staticStyle: {
      color: "#FF0000"
    }
  }, [_vm._v("-1.2%")]), _c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260615/1781508095488.png",
      alt: ""
    }
  })])])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title"
  }, [_c("div", {
    staticClass: "title-bg"
  }, [_c("div", {
    staticClass: "line"
  }), _c("div", {
    staticClass: "title-bg-content"
  }, [_c("i", {
    staticClass: "el-icon-caret-right"
  })])]), _c("div", {
    staticClass: "text"
  }, [_vm._v("生物量模型")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };